import {
  Component,
  ViewEncapsulation,
  OnInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  BehaviorSubject,
  Observable
  , Subscription
} from 'rxjs';
import {
  CommissionsService
} from './commissions.service';
import {
  FormControl
} from '@angular/forms';
import {Router} from '@angular/router';
import {UserContext} from "../services/user-context/user-context";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../services/api/api.service';
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {LocationSummaryService} from '../services/location-summary-service';
import {SearchContext} from '../services/search/search-context';
import * as moment from 'moment';



@Component({
  selector: 'app-commissions',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'commissions.template.html'
})
export class CommissionsComponent implements OnInit {
  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  totals = {};

  start: Date = moment().subtract(30, 'days').toDate();
  end: Date = moment().toDate();
  individualMode = !this.userContext.hasRole('manager');
  allUsers = this.userContext.hasRole('manager');

  public search: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private searchSubscription: Subscription;


  loading = false;

  constructor(
    private router: Router,
    private service: CommissionsService,
    public dialog: MatDialog,
    private searchContext: SearchContext,
    private api: ApiService,
    private locationSummaryService: LocationSummaryService,
    private snackBar: MatSnackBar,
    private userContext: UserContext) {

    this.view = service;
  }

  public ngOnInit(): void {
    this.searchSubscription = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
      if ((term || "").length >= 3 || (term || "").length === 0) {
        this.state.skip = 0;
        this.search.next(term || "");
      }
    });
    this.search.subscribe(term => {
      this.getCommissions();
    });
    this.subscription = this.view.subscribe(result => {
      if( result.data.length ) {
        for( const key of Object.keys(result.data[0])) {
          if(key.endsWith("$")) {
            this.totals[ key.substring(0,key.lastIndexOf("$"))] = result.data[0][key];
          }
        }
      }
    });
  }

  public ngOnDestroy(): void {
    this.search.unsubscribe();
    this.subscription.unsubscribe();
  }

  public totalForColumn(field:string) {
    return this.totals[field] || 0.0;
  }

  public selectedRow(event: SelectionEvent) {
      this.userContext.account = event.selectedRows[0].dataItem;
      this.locationSummaryService.locationObserver.next(true);
      this.router.navigate(['', 'accounts', `${event.selectedRows[0].dataItem._id}`]);
  }

  public filterFieldChanged(): void {
    this.getCommissions();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getCommissions();
  }

  public getCommissions() {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getList(page, limit, this.start, this.end, this.individualMode, this.allUsers, this.search.value);
  }

}
